export class PutUserSalesManagerParam {
    constructor(private userId: number, private salesManagerUserId: number){
        
    }
}


// WEBPACK FOOTER //
// ./src/app/services/sales/model/PutUserSalesManagerParam.ts